module.exports = __webpack_public_path__ + "static/media/head-side-brain.1e472af7.svg";